// extracted by mini-css-extract-plugin
export default {"home":"home_home__pQjws","home__img":"home_home__img__bOW2B","upDown":"home_upDown__ymbJk","home__text":"home_home__text__vu9h5"};